import { AppHeader } from 'packages/lib/common-ui/app-shell/app-header';
import { ToastMessageContainer } from 'packages/lib/common-ui/toast/toast-messages';
import { Layout, ConfigProvider, theme } from 'antd';
import { FC, PropsWithChildren, Suspense } from 'react';

const { Content } = Layout;

export const AppLayout: FC<PropsWithChildren> = ({ children }) => {
  return (
    <ConfigProvider
      theme={{
        algorithm: [theme.compactAlgorithm],
      }}
    >
      <Layout style={{ height: '100vh', width: '100vw', color: '#000' }}>
        <Layout style={{ height: '100%' }}>
          <AppHeader />
          <Content
            style={{
              overflowY: 'auto',
              overflowX: 'hidden',
              position: 'relative',
            }}
          >
            <Suspense fallback={null}>{children}</Suspense>
            <ToastMessageContainer />
          </Content>
        </Layout>
      </Layout>
    </ConfigProvider>
  );
};
export default AppLayout;
